import React, {useMemo} from 'react';
import {Box, Button} from '@mui/material';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {NEW_PLAN_ID} from '../CreateRecommend/RecommendSourceDestination/constants';
import {POTS_BOND} from '../../../utils/potsFilter';
import {
  SetValuesWithSourceKey,
  useAutoForm,
} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';

export interface convertProps {
  values: recommendFieldsType;
  setValues: SetValuesWithSourceKey<recommendFieldsType>;
}

export interface ConvertProps extends convertProps {
  disabled: boolean;
}

export const convertNewPlanToContributeFactory = ({
  values,
  setValues,
}: Omit<ConvertProps, 'disabled'>) => {
  return () => {
    const newPlanToContributeValues: recommendFieldsType = {
      ...values,
      contribute: {
        ...values.contribute!,
        newPlan: values.setUpNew!.newPlan,
        contributeTo: NEW_PLAN_ID,
      },
      planAction: OVRecommendActionEnum.CONTRIBUTE,
      forcedMainPlanType: values.mainPlanType,
    };
    setValues(UPDATES._528, {...newPlanToContributeValues}, true);
  };
};

export const convertNewPlanToTransferFactory = ({
  values,
  setValues,
}: Omit<ConvertProps, 'disabled'>) => {
  return () => {
    const newPlanToTransferValues: recommendFieldsType = {
      ...values,
      transfer: {
        ...values.transfer!,
        newPlan: values.setUpNew!.newPlan,
        destinationAccount: NEW_PLAN_ID,
      },
      planAction: OVRecommendActionEnum.TRANSFER,
      forcedMainPlanType: values.mainPlanType,
    };
    setValues(UPDATES._529, {...newPlanToTransferValues}, true);
  };
};

export const SetupNewConvert: React.FC<{disabled: boolean}> = ({disabled}) => {
  const {values, setValues} = useAutoForm<recommendFieldsType>();

  const convertNewPlanToContribute = useMemo(
    () => convertNewPlanToContributeFactory({values, setValues}),
    [values, setValues]
  );

  const convertNewPlanToTransfer = useMemo(
    () => convertNewPlanToTransferFactory({values, setValues}),
    [values, setValues]
  );

  return (
    <Box mt={1} mb={2} mr={2} display="flex" justifyContent="end">
      <Button
        variant="contained"
        color="secondary"
        disabled={disabled}
        onClick={convertNewPlanToContribute}
      >
        Contribute to this New Plan
      </Button>
      <Box mr={2} />
      {values.mainPlanType !== POTS_BOND && (
        <Button
          variant="contained"
          color="secondary"
          disabled={disabled}
          onClick={convertNewPlanToTransfer}
        >
          Transfer to this New Plan
        </Button>
      )}
    </Box>
  );
};
